import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from '../../../services/api';
import { Globals } from '../../../services/globals';
import { Utility } from 'src/app/services/utility';
import { IUser } from '../../../../../../../common/common-interfaces/user';

@Component({
    selector: 'admin-users',
    templateUrl: './admin-users.component.html',
    styleUrls: ['./admin-users.component.scss'],
    standalone: false
})
export class AdminUsersComponent {
  users: IUser[];
  filter: string = '';
  showDisabledUsers: boolean = false;
  savingUserIds: { [id: string]: boolean } = {};
  errorUserIds: { [id: string]: boolean } = {};

  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }

  async ngOnInit() {
    this.globals.loadAdminKey();
    await this.fetchUsers();
  }

  async fetchUsers() {
    this.users = await this.api.admin().get<any>(`/users`);

    for (let user of this.users) {
      if (!user.settings)
        user.settings = {};
    }
  }

  displayedUsers() {
    if (!this.users)
      return [];

    let filter = (this.filter || '').trim().toLowerCase();

    return this.users.filter(user => {
      if (!this.showDisabledUsers && user.disabled)
        return false;

      if (!filter)
        return true;

      return `${user.username || ''} ${user.name || ''}`.toLowerCase().includes(filter);
    });
  }

  async settingsChanged(user: IUser) {
    this.savingUserIds[user._id] = true;
    this.errorUserIds[user._id] = false;

    try {
      let updatedUser = await this.api.admin().patch<IUser>(`/users/${user._id}/settings`, {
        settings: user.settings
      });

      user.settings = updatedUser.settings || {};

      // Make sure the theme of the currently logged in superadmin is updated right away
      if (this.globals.currentUser && String(this.globals.currentUser._id) == String(user._id)) {
        this.globals.currentUser.settings = user.settings;
        this.globals.applyUserTheme();
      }
    }
    catch (e) {
      console.log(`Failed to save user settings: ${e}`);
      this.errorUserIds[user._id] = true;
      await this.fetchUsers();
    }
    finally {
      this.savingUserIds[user._id] = false;
    }
  }
}
